const getKey = (bookingId) => `TIMER_${bookingId}`;

const getStoredMmtId = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get('mmtId') || params.get('encryptedMmtId');
    if (fromUrl) return fromUrl;
    return JSON.parse(localStorage.getItem('currentMMTBookingId'));
  } catch (error) {
    return null;
  }
};

export const updateTimer = (bookingId) => {
  try {
    if (!bookingId) return;
    const timer = localStorage.getItem(getKey(bookingId));
    if (!timer) {
      localStorage.setItem(getKey(bookingId), JSON.stringify(Date.now()));
    }
  } catch (error) {
    console.error("Error while updating timer");
  }
};

export const clearTimer = (bookingId) => {
  try {
    const id = bookingId || getStoredMmtId();
    if (!id) return;
    localStorage.removeItem(getKey(id));
  } catch (error) {
    console.error("Error while clearing timer");
  }
};

/** Force-start a fresh 10-min window (used after successful booking resume). */
export const resetTimer = (bookingId) => {
  try {
    const id = bookingId || getStoredMmtId();
    if (!id) return;
    localStorage.setItem(getKey(id), JSON.stringify(Date.now()));
  } catch (error) {
    console.error("Error while resetting timer");
  }
};

export const getLatestTimer = () => {
  try {
    const bookingId = getStoredMmtId();
    const time = localStorage.getItem(getKey(bookingId));
    if (time) {
      const storedTime = JSON.parse(time);
      return {
        success: true,
        time: storedTime
      }
    }
    throw new Error("Time has not been set yet.")
  } catch (error) {
    console.trace("Error while fetching timer", error.message);
    return {
      success: false,
      time: Date.now()
    }
  }
};
